export default __webpack_public_path__ + "static/beige-nr-gravel-bananatex-4a390c0caf15bb5ee3f8454e9c8f9c82.png";